import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap';
import AuthLayout from '../../Components/Layouts/AuthLayout';
import { Breadcrumbs } from '../../Components/Breadcrumbs';
import { register } from '../../Services/authService';
import { Helmet } from "react-helmet-async";

const RegisterScreen = () => {
    const [user, setUser] = useState({
        name: '',
        email: '',
        role: '',
        password: '',
        confirm_password: ''

    });

    const registerHandler = (e) => {
        e.preventDefault();
        register(user);
    };

    return (
        <>
         <Helmet>
            <title>Sign up</title>
            <meta name="description" content="This is the Sign up Page of Oasis Education Institute" />
        </Helmet>

            <Breadcrumbs page='Register New User' path="/admin" label='Dashboard' />
            <AuthLayout>
                <Form onSubmit={registerHandler} className="p-4 max-w-xs mx-auto bg-white opacity-80 shadow-lg rounded-lg">
                    <Form.Group className="mb-3" controlId="formBasicName">
                        <Form.Label className="block font-medium text-sm text-gray-700 mb-1">Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter Name" value={user.name} onChange={(e) => setUser({ ...user, name: e.target.value })} required pattern="^[A-Za-z\s]+$"
                            isInvalid={user.name && !user.name.match(/^[A-Za-z\s]+$/)} />
                        <Form.Control.Feedback type="invalid">
                            Name should contain only alphabetic characters.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="block font-medium text-sm text-gray-700 mb-1">Email address</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" value={user.email} onChange={(e) => setUser({ ...user, email: e.target.value })} required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                            isInvalid={user.email && !user.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)} />
                        <Form.Control.Feedback type="invalid">
                            Please enter a valid email address.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="block font-medium text-sm text-gray-700 mb-1">Role</Form.Label>
                        <Form.Select aria-label="select a role" value={user.role} onChange={(e)=>setUser({...user,role:e.target.value})} required>
                            <option disabled>Select Role</option>
                            <option value="1">Admin</option>
                            <option value="2">Teacher</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label className="block font-medium text-sm text-gray-700 mb-1">Password</Form.Label>
                        <Form.Control type="password" placeholder="Password" value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} required pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                            isInvalid={user.password && !user.password.match(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)} />
                        <Form.Control.Feedback type="invalid">
                            Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                        <Form.Label className="block font-medium text-sm text-gray-700 mb-1">Confirm Password</Form.Label>
                        <Form.Control type="password" placeholder="Re-enter Password" value={user.confirm_password} onChange={(e) => setUser({ ...user, confirm_password: e.target.value })} required isInvalid={user.password !== user.confirm_password} />
                        <Form.Control.Feedback type="invalid">
                            Password and Confirm Password must be same.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3 block font-medium text-sm text-gray-700 mb-1" controlId="formBasicCheckbox">
                        <Form.Check type="checkbox" label="Remember me" />
                    </Form.Group>

                    <div className="d-grid text-bold">
                        <Button variant="primary" type="submit">
                            Sign up
                        </Button>
                    </div>
                </Form>
            </AuthLayout>
        </>

    )
}

export default RegisterScreen

